<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <form @keydown.enter.prevent="submit()">
      <!-- data provider  -->
      <div>
        <!-- title  -->
        <h2 class="mb-1" style="display: flex">
          {{ $t('Prokūros asmenys')
          }}<el-tooltip
            tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Prokūros asmenys"
            title
          ></el-tooltip>
        </h2>
        <h3 class="mb-1 pt-2" style="display: flex">
          {{ $t('Dokumento sudarytojas')
          }}<el-tooltip
            tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Dokumento sudarytojas"
            subTitle
          ></el-tooltip>
        </h3>
        <div>

            <!-- add person btn -->
      <v-row>
      <v-col cols="12" class="mr-5">
        <el-button
          v-if="showAddPersonJurBtn"
          small
          class="mb-2"
          color="primary"
          icon="pridėti"
          title="Pridėti mane prie juridinio asmens išdavusio prokūrą"
          :loading="loading"
          @click.native.stop="AddPersonBtn(false)"
        />
        <el-button
          v-if="showAddPersonFizBtn"
          small
          class="mb-2"
          color="primary"
          icon="pridėti"
          title="Pridėti mane prie prokuristų"
          :loading="loading"
          @click.native.stop="AddPersonBtn(true)"
        />
      </v-col>
      </v-row>
        </div>
        <v-card outlined>
          <!-- form  -->
          <v-card-text class="pa-0">
            <v-row class="mb-0 pb-0">
              <v-col class="pb-0" cols="12" md="12">
                <el-simple-table :items="documentDataList" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>

      <!-- pro principal  -->
      <div class="pt-3">
        <!-- title  -->
        <h3 class="mb-1" style="display: flex">
          {{ formData.kind == 'ITPP' ? $t('Juridinis asmuo, išdavęs prokūrą') : $t('Juridinis asmuo, išduodantis prokūrą') }}
          <el-tooltip
            tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Juridinis asmuo, išduodantis prokūrą"
            subTitle
          ></el-tooltip>
        </h3>
        <!-- add button  -->
        <el-button
          v-if="showNewPersonBtn"
          class="mb-3"
          small
          color="primary"
          icon="pridėti"
          title="Pridėti asmenį"
          :loading="loading"
          @click.native.stop="newPerson()"
        />
        <v-data-table
          v-if="showPersonsTable"
          class="mb-4 custom-table"
          :loading="loading"
          :headers="headersProPrincipal"
          :items-per-page="1000"
          :items="formData.pro_principals"
          :hide-default-footer="true"
          :header-props="{
            sortByText: $t('Rūšiuoti pagal'),
          }"
        >
          <!-- custom templates -->
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.code }}</td>
              <td>{{ item.fullname }}</td>
              <td>{{ item.other_info }}</td>
              <td>
                <template>
                  <div class="nowrap">
                    <el-table-action
                      :item="setEditProPrincipal(item)"
                      @addJurRepresenterItem="newJurRepresenter(item)"
                      @deleteItem="deleteItem({ item, type: 'pro_principals' })"
                    />
                  </div>
                </template>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <!-- procurators  -->
      <div class="pt-4">
        <!-- title  -->
        <h3 class="mb-1" style="display: flex">
          {{ $t('Prokuristai')
          }}<el-tooltip
            tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Prokuristai"
            subTitle
          ></el-tooltip>
        </h3>
        <!-- add button  -->
        <el-button
          v-if="showAddProcurator"
          small
          class="mb-3"
          color="primary"
          icon="pridėti"
          title="Pridėti prokuristą"
          :loading="loading"
          @click.native.stop="newProcurator()"
        />
        <v-data-table
          v-if="showProcuratorsTable"
          class="mb-4 custom-table"
          :loading="loading"
          :headers="headersProcurator"
          :items="formData.procurators"
          :hide-default-footer="true"
          :items-per-page="1000"
          :header-props="{
            sortByText: $t('Rūšiuoti pagal'),
          }"
        >
          <template #[`item.selectedCode`]="{ item }">
            {{ item.code || item.iltu_code }}
          </template>
          <template #[`item.actions`]="{ item }">
            <div class="nowrap">
              <el-table-action
                :item="setEdit(item, 'procurators')"
                @deleteItem="deleteItem({ item, type: 'procurators' })"
              />
            </div>
          </template>
        </v-data-table>
      </div>
      <!-- actions  -->
      <v-card-actions>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <el-button
            class="mr-1"
            color="secondary"
            icon="atgal"
            title="Atgal"
            @click.native.stop="back()"
            :loading="loading"
          />
          <el-button
            v-if="!modeReadonly"
            title="Tęsti"
            :loading="loading"
            @click.native="next()"
            color="primary"
            icon="pirmyn"
          />
        </v-row>
      </v-card-actions>
      <!-- modal  -->
      <modal-add-person
        v-if="showAddPerson"
        v-model="showAddPerson"
        :modalType="modalType"
        :additionalData="formData"
        @addPersonData="addPerson"
        :showForeignerPp="showForeignerPP"
        addRaw
        mandate
      />
      <modal-delete
        title="Įrašo šalinimas"
        :text="`Ar tikrai norite pašalinti?`"
        :code="getModalDeleteCode"
        v-model="showDelete"
        :item="modalDeleteItem"
        @confirmDelete="confirmDelete"
      />
    </form>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import unsavedData from '@/mixins/unsavedData'
import ModalAddPerson from '@/components/modals/ModalAddPerson'
import ModalDelete from '@/components/modals/ModalDelete'
import InJournalStatus from '@/components/constants/inJournalStatus'
import Enums from '@/enums'

export default {
  name: 'MandateStep2',
  components: {
    ModalAddPerson,
    ModalDelete,
  },
  mixins: [userRole, unsavedData],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      showAddPerson: false,
      loading: false,
      formData: {
        data_provider: {},
        data_provider_representitive: {},
        pro_principals: [],
        procurators: [],
      },
      modalType: null,
      showDelete: false,
      modalDeleteItem: null,
      principalRepresenterId: null,
    }
  },
  computed: {
    showForeignerPP() {
      return this.modalType == 'procurators' && (this.formData.kind == 'PP' ||  this.formData.in_journal_type == '421')
    },
    showAddPersonJurBtn(){
      if(this.formData.data_provider?.type === 'JUR'){
        return  this.formData.pro_principals &&
        this.formData.pro_principals.filter(
          (item) => item.amn_id === this.formData.data_provider.amn_id
        ).length == 0
      } else {
        return false
      }
    },
    showAddPersonFizBtn(){
      if(this.formData.data_provider?.type === 'FIZ' && this.formData.status == 801){
        return  this.formData.procurators &&
        this.formData.procurators.filter(
          (item) => item.amn_id === this.formData.data_provider.amn_id
        ).length == 0
      } else {
        return false
      }
    },
    documentDataList() {
      switch (this.formData.data_provider?.type) {
        case 'FIZ':
          if (this.formData.data_provider?.code) {
            return [
              {
                title: 'Vardas',
                value: this.formData.data_provider?.name || '',
                tooltip:
                  'IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Vardas',
              },
              {
                title: 'Pavardė',
                value: this.formData.data_provider?.lastname || '',
                tooltip:
                  'IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Pavardė',
              },
              {
                title: 'Asmens kodas',
                value: this.formData.data_provider?.code || '',
                tooltip:
                  'IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Asmens kodas',
              },
            ]
          } else {
            return [
              {
                title: 'Vardas',
                value: this.formData.data_provider?.name || '',
              },
              {
                title: 'Pavardė',
                value: this.formData.data_provider?.lastname || '',
              },
              {
                title: 'ILTU kodas',
                value: this.formData.data_provider?.iltu_code || '',
                hide: !this.formData.data_provider?.iltu_code
              },
              // {
              //   title: 'Gimimo data',
              //   value: this.formData.data_provider?.birth_date || '',
              // },
              // {
              //   title: 'Šalis',
              //   value: this.formData.data_provider?.country || '',
              // },
            ]
          }
        case 'JUR':
          return [
            {
              title: 'Juridinio asmens pavadinimas',
              value: this.formData.data_provider?.fullname || '',
              tooltip:
                'IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Juridinio asmens pavadinimas',
            },
            {
              title: 'Juridinio asmens kodas',
              value: this.formData.data_provider?.code || '',
              tooltip:
                'IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Juridinio asmens kodas',
            },
            {
              title: 'Atstovo vardas, pavardė',
              value: this.formData.data_provider.representitive_fullname || '',
              tooltip:
                'IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Atstovo vardas pavardė',
            },
            {
              title: 'Atstovo asmens/ILTU kodas',
              value: this.formData.data_provider.representitive_code || '',
              hide: !this.formData.data_provider.representitive_code,
              tooltip:
                'IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Atstovo asmens kodas',
            },
          ]
        case 'UZS':
          return [
            {
              title: 'ILTU kodas',
              value: this.formData.data_provider?.code || '',
            },
            {
              title: 'Vardas',
              value: this.formData.data_provider?.name || '',
            },
            {
              title: 'Pavardė',
              value: this.formData.data_provider?.lastname || '',
            },
            {
              title: 'Gimimo data',
              value: this.formData.data_provider?.birth_date || '',
            },
            {
              title: 'Šalis',
              value: this.formData.data_provider?.country || '',
            },
          ]
        default:
          return []
      }
    },
    getModalDeleteCode() {
      return this.modalDeleteItem && this.modalDeleteItem.type === 'procurators'
        ? '000071'
        : ''
    },
    showProcuratorsTable() {
      return this.formData.procurators && this.formData.procurators.length > 0
    },
    showNewPersonBtn() {
      return this.formData.pro_principals.length < 1 && this.formData.data_provider?.type !== 'JUR'
    },
    showPersonsTable() {
      return this.formData.pro_principals && this.formData.pro_principals.length > 0
    },
    showAddProcurator() {
      if(this.formData.procuracy_type == "sole"){
        return this.formData.procurators.length < 1
      }
      return true
    },
    getId() {
      return this.$route.params.id || null
    },
    modeReadonly() {
      return false
    },
    headersProPrincipal() {
      return [
        {
          text: this.$t('Asmens kodas'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Pavadinimas'),
          align: 'start',
          value: 'fullname',
          width: '18rem',
        },
        {
          text: this.$t('Kita informacija'),
          align: 'start',
          value: 'other_info',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
    },
    headersProcurator() {
      return [
        {
          text: this.$t('Asmens/ILTU kodas'),
          align: 'start',
          value: 'selectedCode',
        },
        {
          text: this.$t('Vardas pavardė'),
          align: 'start',
          value: 'fullname',
          width: '18rem',
        },
        {
          text: this.$t('Fizinio asmens identifikavimo kodas užsienio valstybėje'),
          align: 'start',
          value: 'foreigner_code',
        },
        {
          text: this.$t('Kita informacija'),
          align: 'start',
          value: 'other_info',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
    },
  },
  created() {
    this.getClassifiers()
    this.getData()
  },
  methods: {
    getClassifiers() {
      this.enumsClassifiers = Enums
    },
    setEditProPrincipal(item) {
      if (item.type == 'JUR') {
        this.$set(item, 'addJurRepresenter', false)
      } else {
        this.$set(item, 'addJurRepresenter', false)
      }
      item.canDelete = this.formData.data_provider?.type !== 'JUR' && this.formData.status != InJournalStatus.ATSTOVAI_PATVIRTINTI
      return item
    },
    setEditRepresenter(representer) {
      representer.canDelete = true
      return representer
    },
    setEdit(item, type) {
      if (type === 'pro-principal' || type === 'jur_representers') {
        return item
      }
      item.canDelete = true
      return item
    },
    newPerson() {
      this.modalType = 'pro_principals'
      this.showAddPerson = true
    },
    newJurRepresenter(item) {
      this.modalType = 'jur_representers'
      this.showAddPerson = true
      this.principalRepresenterId = item.amn_id
    },
    newProcurator() {
      this.modalType = 'procurators'
      this.showAddPerson = true
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      if (item.type == 'jur_representers') {
        const index = this.formData.pro_principals.findIndex(
          (formItem) => formItem.amn_id === item.proPrincipalAmnId
        )
        const representersIndex = this.formData
                                        .pro_principals[index]
                                        .jur_representers
                                        .findIndex(formItem => formItem.amn_id === item.representer.amn_id)
        if (representersIndex > -1) {
          this.formData.pro_principals[index].jur_representers.splice(representersIndex, 1)
        }
      } else {
        const index = this.formData[item.type].findIndex(formItem => formItem.amn_id === item.item.amn_id)
        if (index > -1) {
          this.formData[item.type].splice(index, 1)
        }
      }
      this.showDelete = false
    },
    addPerson(item) {
      if (item.modalType === 'pro_principals') {
        item.jur_representers = item.signing_persons
        this.formData.pro_principals.push(item)
      } else if (item.modalType === 'procurators') {
        item.selectedCode = item.code
        this.formData.procurators.push(item)
      } else if (item.modalType === 'jur_representers') {
        const index = this.formData.pro_principals.findIndex(
          (principal) => principal.amn_id === this.principalRepresenterId
        )
        if (typeof this.formData.pro_principals[index].jur_representers == 'undefined') {
          this.formData.pro_principals[index].jur_representers = []
        }
        //
        let exist = this.formData.pro_principals[index].jur_representers.filter(
          (representer) => representer.amn_id === item.amn_id && item.amn_id != 'new_id'
        ).length
        if (exist) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
        }
        //
        this.formData.pro_principals[index].jur_representers.push(item)
      }
      this.showAddPerson = false
    },
    next() {
       if (this.formData.status == InJournalStatus.ATSTOVAI_PATVIRTINTI) {
         if (this.formData.status != '801' &&  this.formData.procuracy_type == "general" && this.formData.procurators.length < 2) {
           return this.$root.$emit('DATA_ERROR_CODE', '000087')
         }
        this.$emit('gotoStep', { step: '3', id: this.getId })
      } else {
        this.saveData()
      }
    },
    back() {
      if (this.formData.status == InJournalStatus.ATSTOVAI_PATVIRTINTI) {
        this.$emit('gotoStep', { step: '1', id: this.getId })
      } else {
        // this.goToRoute()
        this.$emit('gotoStep', { step: '1', id: this.getId })
      }
    },
    getData() {
      if (this.getId) {
        this.pageloading = true

        this.$axios
          .get(`in-journals/${this.getId}`)
          .then((res) => {
            this.formData = res.data.inJournal
            this.formData.data_provider = this.formData.data_provider || {}
            this.formData.data_provider_representitive =
              this.formData.data_provider_representitive || {}
            //
            this.formData.pro_principals =
              this.formData.pro_principals || this.$set(this.formData, 'pro_principals', [])
            this.formData.procurators =
              this.formData.procurators ||
              this.$set(this.formData, 'procurators', [])

              this.formData.procurators.map(item => item.selectedCode = item.code || item.iltu_code);
            this.initialForm()
            if([803,804,807,808,810,811,812,813,815,816].includes(this.formData.status)){
              this.$router.push({ name: 'savDocuments' })
            }
          })
          .catch((err) => {
            if (err.response.status === 404) {
              return this.$router.push({ name: 'sav404' })
            } else {
              this.$root.$emit('DATA_ERROR', err.response.data.message)
            }
          })
          .finally(() => {
            this.pageloading = false
          })
      }
    },
    checkPerson(personData) {
      let code = personData.code
      let type = personData.type
      let dataType = personData.modalType
      this.$axios
        .post('persons/checkPerson', { code: code, type: type, dataType: dataType })
        .then(() => {
          this.addPerson(personData)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    rowClass() {
        return `row-red`
    },
    AddPersonBtn(procurators) {
      this.loading = true
      let formData = this.formData.data_provider
      formData.dataType =  procurators ? 'procurators' : 'proPrincipal'
      let url = ''
      if (formData.code) {
        url = `persons/getByAsmCode`
      } else {
        url = `persons/getForeignerByBirthDate`
      }
      let personData = {}
      this.$axios
        .post(url, formData)
        .then((res) => {
          personData = res.data.person
          personData.type = this.formData.data_provider.type
          personData.modalType = procurators ? 'procurators' : 'proPrincipal'
          this.checkPerson(personData)
         
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.loading = false
        })
        
    },
    saveData(toRoute) {
      this.$validator.validateAll().then((res) => {
        if (this.formData.pro_principals.length === 0 && !toRoute) {
          return this.$root.$emit('DATA_ERROR_CODE', '000085')
        }
        if (this.formData.procurators.length === 0 && !toRoute) {
          return this.$root.$emit('DATA_ERROR_CODE', '000086')
        }
        if (this.formData.procuracy_type == "general" && this.formData.procurators.length < 2 && !toRoute) {
          return this.$root.$emit('DATA_ERROR_CODE', '000087')
        }
        if (this.formData.procuracy_type == "sole" && this.formData.procurators.length > 1 && !toRoute) {
          return this.$root.$emit('DATA_ERROR_CODE', '000091')
        }
        if (res) {
          this.loading = true
          let formData = this.formData
          if (toRoute) {
            formData.button = 'back'
          } else {
            formData.button = 'next'
          }
          let url = `in-journals/${this.getId}/mandate-persons`
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_STEP')
              // then
              this.initialForm()
              if (toRoute) {
                this.goToRoute()
              } else {
                this.$emit('gotoStep', { step: '3', id: this.getId })
              }
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR_STEP')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>